module.exports = __webpack_public_path__ + "static/media/about-us.e51a1e43.png";